<template>
  <div id="workflow-create-new">
    <div class="modal workflow-create-new-modal">
      <div class="modal-background" @click="closeModal"></div>
      <button class="modal-close is-large" @click="closeModal"></button>

      <div class="modal-card">
        <section class="modal-card-body">
          <p class="subtitle is-4 has-text-info" style="margin-bottom: 6px">
            Create Workflow
          </p>
          <div class="notification" v-show="!addingStops" style="padding: 10px">
            <div class="field is-horizontal">
              <div class="field-body">
                <div class="field is-narrow">
                  <div class="control has-icons-left">
                    <div class="select is-fullwidth is-medium">
                      <select v-model="workflowType" @change="onWorkflowType">
                        <option value disabled selected>
                          -- Select Workflow --
                        </option>
                        <option>Fleet</option>
                        <!-- <option>Public Tuk Tuk</option> -->
                        <option>Private Tuk Tuk</option>
                        <!-- <option>Sii Lor</option>
                        <option>Songthaew</option>
                        <option>Motocy</option>
                        <option>Taxi</option> -->
                        <option>Agent</option>
                        <option>Delivery</option>
                        <option>Logistics</option>
                        <option>Commerce</option>
                        <!-- <option>Other</option> -->
                        <option>Admin</option>
                        <option>Accounting</option>
                        <!-- <option>-- Cancel --</option> -->
                      </select>
                    </div>
                    <span class="icon is-small is-left">
                      <i class="fas fa-running"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="isTransportWorkflow">
              <div class="field">
                <p class="control has-icons-left">
                  <input
                    class="input is-medium"
                    v-model="workflowName"
                    type="text"
                    placeholder="Workflow Name"
                  />
                  <span class="icon is-small is-left">
                    <i class="fas fa-signature"></i>
                  </span>
                </p>
              </div>

              <div class="field">
                <p class="control has-icons-left">
                  <input
                    class="input is-medium"
                    v-model="phoneNumber"
                    type="text"
                    placeholder="Phone Number"
                  />
                  <span class="icon is-small is-left">
                    <i class="fas fa-phone"></i>
                  </span>
                </p>
              </div>

              <div class="field">
                <p class="control has-icons-left">
                  <input
                    class="input is-medium"
                    v-model="workflowInfo"
                    type="text"
                    placeholder="Information"
                  />
                  <span class="icon is-small is-left">
                    <i class="fas fa-info"></i>
                  </span>
                </p>
              </div>

              <div class="field">
                <p class="control has-icons-left">
                  <input
                    class="input is-medium"
                    v-model="operatingHours"
                    type="text"
                    placeholder="Hours of operation"
                  />
                  <span class="icon is-small is-left">
                    <i class="fas fa-clock"></i>
                  </span>
                </p>
              </div>

              <div
                class="field has-addons"
                v-for="stop in stops"
                :key="stop.number"
              >
                <div class="control has-icons-left is-expanded">
                  <input
                    class="input is-fullwidth"
                    :class="{ 'is-danger': !stop.name }"
                    type="text"
                    v-model="stop.name"
                  />
                  <span class="icon is-small is-left">
                    <i class="fas fa-map-pin"></i>
                  </span>
                </div>
                <div class="control">
                  <a class="button" @click="deleteStop(stop.number)">
                    <i class="fa fa-minus-circle" />
                  </a>
                </div>
              </div>

              <div class="field">
                <p class="control">
                  <button
                    class="button is-warning is-fullwidth is-medium"
                    @click="addStops"
                  >
                    Add Stop
                  </button>
                </p>
              </div>

              <div class="field" v-show="stops.length >= minStops">
                <p class="control">
                  <button
                    class="button is-link is-fullwidth is-medium"
                    @click="submit"
                  >
                    Create
                  </button>
                </p>
              </div>
            </div>

            <div v-else-if="isNonTransportWorkflow">
              <div class="field">
                <span
                  class="button is-success is-medium is-fullwidth is-rounded"
                  @click="createNonTransportWorkflow"
                  >Create</span
                >
              </div>
            </div>
          </div>

          <div v-show="addingStops">
            <div class="field has-addons" style="margin-bottom: 2px">
              <p class="control has-icons-left is-expanded">
                <input
                  id="google-autocomplete"
                  class="input is-medium"
                  ref="autocomplete"
                  placeholder="Stop"
                  onfocus="value = ''"
                  type="text"
                />
                <span class="icon is-small is-left">
                  <i class="fas fa-map-pin" />
                </span>
              </p>
              <div class="control">
                <a
                  class="button is-danger is-medium"
                  @click="cancelStopLocation"
                >
                  <i class="fa fa-times-circle" />
                </a>
              </div>
            </div>

            <WorkflowCreateStop />

            <div class="field">
              <span
                class="button is-success is-medium is-fullwidth"
                @click="setStopLocation"
                >Set Stop Location</span
              >
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus.js";
import WorkflowCreateStop from "@/components/WorkflowCreateStop.vue";
import $Scriptjs from "scriptjs";

export default {
  name: "WorkflowCreateNew",
  components: { WorkflowCreateStop },
  data() {
    return {
      autocomplete: undefined,
      place: undefined, // google place result
      placeCoords: null,
      workflowType: null, //"Private Tuk Tuk",
      workflowName: "Tuk Tuk",
      workflowInfo: "",
      phoneNumber: "+66",
      operatingHours: "",
      stops: [], // stop {number, name, coords}
      addingStops: false,
      minStops: 2,
    };
  },
  computed: {
    business() {
      return this.$store.state.selectedBusiness;
    },
    shortURL() {
      var url = this.url;
      var split = url.split("//");
      if (split.length > 1) url = split[1];
      split = url.split("/");
      if (split.length > 1) url = split[0];
      return url;
    },
    isTransportWorkflow() {
      var transport = [
        "Public Tuk Tuk",
        "Private Tuk Tuk",
        "Sii Lor",
        "Songthaew",
        "Motocy",
        "Taxi",
      ];
      if (transport.includes(this.workflowType)) return true;
      return false;
    },
    isNonTransportWorkflow() {
      var nontransport = [
        "Agent",
        "Admin",
        "Delivery",
        "Logistics",
        "Commerce",
        "Accounting",
        "Other",
        "Fleet", // new idea... used by Logistics for now
      ];
      if (nontransport.includes(this.workflowType)) return true;
      return false;
    },
  },
  mounted() {
    var googlePlacesURL = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBYOwhqakcxLQQLpljhkug2WsNSA02cqss&libraries=places`;
    $Scriptjs(googlePlacesURL, () => this.setupGooglePlaces());

    // set the first stop as the business location
    this.stops.push({
      id: this.newUUID(),
      number: 1,
      name: this.business.name,
      lat: this.business.lat,
      lon: this.business.lon,
    });
  },
  methods: {
    setupGooglePlaces() {
      this.autocomplete = new google.maps.places.Autocomplete(
        this.$refs.autocomplete,
        {
          types: [], // uses all, options are ["address", "establishment", "geocode"]
          // componentRestrictions: { country: "th" }
        }
      );
      this.geolocate();

      this.autocomplete.addListener("place_changed", () => {
        var place = this.autocomplete.getPlace();
        var coords = [
          place.geometry.location.lat(),
          place.geometry.location.lng(),
        ];
        this.$store.commit("setGooglePlace", { place: place, coords: coords });
        this.console("place", place);
      });
    },
    closeModal() {
      // reset data
      this.workflowName = "Tuk Tuk";
      this.phoneNumber = "+66";
      this.stops = [];
      this.addingStops = false;
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    createNonTransportWorkflow() {
      var loader = this.loadingDots();
      this.$store
        .dispatch("createWorkflow", {
          business_id: this.business.id,
          name: this.workflowType,
          workflow_type_name: this.workflowType,
          created_by: this.$store.state.user.id,
        })
        .then(() => this.updateWorkflowsForBusiness())
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    onWorkflowType() {
      if (this.workflowType === "-- Cancel --") this.closeModal();
      if (
        this.workflowType === "Sii Lor" ||
        this.workflowType === "Songthaew" ||
        this.workflowType === "Public Tuk Tuk" ||
        this.workflowType === "Motocy" ||
        this.workflowType === "Taxi"
      ) {
        this.workflowName = this.workflowType;
        this.minStops = 1;
      }
    },
    addStops() {
      if (this.stops.some((el) => el.name === "")) {
        this.$swal("Set stop name");
        return;
      }
      this.addingStops = true;
      this.$refs.autocomplete.value = "";
      EventBus.$emit("ADDING_STOPS", null); // trigger to redraw map in WorkflowCreateStop
    },
    cancelStopLocation() {
      this.console("cancel");
      this.addingStops = false;
    },
    setStopLocation() {
      if (this.$refs.autocomplete.value === "") {
        this.$store.commit("notGooglePlace");
        // this.$swal("Give it a name!");
      }
      this.addingStops = false;
      var newStop = {
        id: this.newUUID(),
        number: this.stops.length + 1,
        name: this.$store.getters.stopName,
        lat: this.$store.state.stopCoords.lat,
        lon: this.$store.state.stopCoords.lng,
        // coords: this.$store.state.stopCoords
      };
      this.stops.push(newStop);
      this.console("stops", this.stops);
    },
    deleteStop(stopNumber) {
      this.console("deleteStop", stopNumber);
      this.stops.splice(stopNumber - 1, 1);
      this.stops.forEach((stop, index) => (stop.number = index + 1)); // reset stop numbers
    },
    // Bias autocomplete to the user's location,
    geolocate() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          var geolocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          var circle = new google.maps.Circle({
            center: geolocation,
            radius: position.coords.accuracy,
          });
          this.autocomplete.setBounds(circle.getBounds());
        });
      }
    },
    submit() {
      if (this.workflowType === "") {
        this.$swal("Set workflow type");
        return;
      }
      if (this.stops.some((el) => el.name === "")) {
        this.$swal("Set stop name");
        return;
      }
      var loader = this.loadingDots();
      this.$store
        .dispatch("createWorkflow", {
          business_id: this.business.id,
          name: this.workflowName,
          workflow_type_name: this.workflowType,
          created_by: this.$store.state.user.id,
          data: {
            phone_number: this.phoneNumber,
            info: this.workflowInfo,
            operating_hours: this.operatingHours,
            stops: this.stops,
          },
        })
        .then(() => this.updateWorkflowsForBusiness())
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    updateWorkflowsForBusiness() {
      this.$store
        .dispatch("getWorkflows", this.business.id)
        .then(() => {
          this.successToast("Success!");
          this.closeModal();
        })
        .catch((err) => this.apiError(err));
    },
  },
};
</script>

<style scoped>
.modal-card-body {
  padding: 10px;
}
.notification {
  margin-bottom: 0;
}
</style>